import { useCMSPageField } from '@/cms/fields'
import { CMSMediaType } from '@/cms/fields/mappers/productDetailPageFieldsMapper'
import { useIntl } from '@/intl'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Image } from '@sunwebgroup/uds-ui/image'
import { useState } from 'react'
import { FullScreenGallery } from '../../../common/components/FullScreenGallery'
import style from './Video.module.css'

export function Video() {
  const intl = useIntl()
  const [showGalleryIndex, setShowGalleryIndex] = useState<number | null>(null)
  const videos = useCMSPageField('DestinationPage.videos')

  const handleKeyDown = (index: number) => (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      setShowGalleryIndex(index)
    }
  }

  if (!videos || videos.length === 0) {
    return null
  }

  return videos.map((video, index) => (
    <div key={`destination-video-${index}`}>
      <div className={style.video} onClick={() => setShowGalleryIndex(index)} onKeyDown={handleKeyDown(index)} tabIndex={0}>
        <Image src={video.thumbnail} alt="" />
        <Icon
          glyph="Play"
          aria-label={intl.formatMessage({ id: 'photo_gallery_play_video' })}
          className={style.playIcon}
        />
      </div>
      {showGalleryIndex === index && (
        <FullScreenGallery
          onClose={() => setShowGalleryIndex(null)}
          open={showGalleryIndex === index}
          media={[{ type: CMSMediaType.VIDEO, src: video.thumbnail, link: video.link, alt: '' }]}
        />
      )}
    </div>
  ))
}
